import type { VueKeycloakTokenParsed } from '@dsb-norge/vue-keycloak-js';
import config from '@/config/keycloak';

export enum Permission {}

export function tokenHasRequiredResourceAccess(token: VueKeycloakTokenParsed): boolean {
  return !!token.resource_access && !!token.resource_access[config.clientId + '-api'];
}
